import Vue from 'vue';

var urlBase = '/inspection-api/';

export default {
    actions: {
      //this fetches a result and commits it
      //convenient but probably going to deprecate as it is controlling too much
      fetchAndStore : function( context, endpoint, commitMessage ){
       // console.log('fetch and store',endpoint);

        return new Promise((resolve) => {
          Vue.http.get( urlBase + endpoint ).then((response) => {
            context.commit( commitMessage,  response );
            resolve();
          });
        });
      },
      //this just fetches
      fetch : function( endpoint ){
        //console.log('fetch',endpoint);

        return Vue.http.get( urlBase + endpoint ); //returns a promise
      },
      post : function( endpoint, payload ){
       // console.log('post',endpoint);

        return Vue.http.post( urlBase + endpoint, payload, {
          emulateJSON: true
        });
      },
      fetchWithToken : function( endpoint, token ){
       // console.log('fetchwithtoken',endpoint,'with token',token);
        return Vue.http.get( urlBase + endpoint, {
          'headers' : {
            'Authorization' : 'Bearer ' + token
          }
        });
      },
      postAndReceive : function( context, endpoint, payload, commitMessage ){
       // console.log('postandreceive',endpoint);

        return new Promise((resolve) => {
          Vue.http.post( urlBase + endpoint, payload, {
            emulateJSON: true
          } ).then((response) => {
            context.commit( commitMessage,  response );
            resolve();
          });
        });
      },
      //To be deprecated due to promise antipattern
      getWithToken : function( endpoint, token ){
       // console.log('getwithtoken',endpoint,'with token',token);

        return new Promise((resolve) => {
          Vue.http.get( urlBase + endpoint, {
            headers : {
              Authorization : 'Bearer ' + token
            }
          } ).then((response) => {
            resolve( response );
          });
        });
      },
      postWithToken : function( endpoint, token, payload ){
       // console.log('postwithtoken',endpoint,'with token',token);

        return Vue.http.post( urlBase + endpoint, JSON.stringify(payload), {
            headers : {
              'Authorization' : 'Bearer ' + token,
              'Content-Type': 'text/plain'
            }
          });
      },
      postBinaryWithToken : function( endpoint, token, payload ){
        //console.log('postbinarywithtoken',endpoint,'with token',token);
        return Vue.http.post( urlBase + endpoint, payload, {
          headers : {
            'Authorization' : 'Bearer ' + token,
            'Content-Type': 'multipart/form-data'
          }
        });
      },
      defer : function() {  //simple observer that can be resolved externally
        var res, rej;

        var promise = new Promise((resolve, reject) => {
          res = resolve;
          rej = reject;
        });

        promise.resolve = res;
        promise.reject = rej;

        return promise;
      }
    }
  }